import { Link } from 'react-router-dom';
import { HiHome } from 'react-icons/hi';

const NotFound = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="max-w-md w-full text-center">
        {/* Animated 404 Illustration */}
        <div className="relative mb-8">
          <div className="text-[150px] font-black text-indigo-600/10 leading-none select-none animate-pulse">
            404
          </div>
          <div className="absolute inset-0 flex items-center justify-center">
            <h1 className="text-6xl font-extrabold text-gray-900 tracking-tight">404</h1>
          </div>
        </div>

        {/* Content */}
        <div className="space-y-4">
          <h2 className="text-3xl font-bold text-gray-900">Oops! Page not found</h2>
          <p className="text-gray-500 text-lg max-w-sm mx-auto leading-relaxed">
            The page you're looking for doesn't exist or has been moved to a new URL.
          </p>
        </div>

        {/* Actions */}
        <div className="mt-10">
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 bg-indigo-600 hover:bg-indigo-700 text-white font-semibold py-3.5 px-8 rounded-2xl shadow-lg shadow-indigo-200 transition-all hover:-translate-y-0.5 active:translate-y-0"
          >
            <HiHome className="text-xl" />
            <span>Back to Dashboard</span>
          </Link>
        </div>

        {/* Decorative elements */}
        <div className="mt-16 flex justify-center gap-4">
          <div className="w-2 h-2 rounded-full bg-indigo-200 animate-bounce [animation-delay:-0.3s]"></div>
          <div className="w-2 h-2 rounded-full bg-indigo-300 animate-bounce [animation-delay:-0.15s]"></div>
          <div className="w-2 h-2 rounded-full bg-indigo-400 animate-bounce"></div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
